<template>
  <div class="chart-box">
    <el-row :gutter="20" style="margin: 30px 0;">
      <el-col :span="6">
        <centerLeft defultIndex="2-1" />
      </el-col>
      <el-col :span="18">
        <el-card class="box-card" shadow="never">
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            class="type-opr"
            style="margin:0 0  10px 0;"
          >
            <el-breadcrumb-item :to="{ path: '/center/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>成果提交</el-breadcrumb-item>
          </el-breadcrumb>
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>基本信息</span>
            </div>
            <el-form :rules="rules" ref="dataForm" :model="dataForm" label-width="120px">
              <el-form-item label="成果类型">
                <el-input disabled="disabled" value="外文论文"></el-input>
              </el-form-item>
              <el-form-item label="标题(中文)">
                <el-input v-model="dataForm.chtitle"></el-input>
              </el-form-item>
              <el-form-item label="标题(外文)">
                <el-input v-model="dataForm.title"></el-input>
              </el-form-item>
              <el-form-item label="作者">
                <el-input v-model="authors" @focus="dialogVisible1=true"></el-input>
              </el-form-item>
              <el-form-item label="期刊ISSN">
                <el-input v-model="dataForm.issn"></el-input>
              </el-form-item>
              <el-form-item label="期刊名">
                <el-input v-model="dataForm.journalName"></el-input>
              </el-form-item>
              <el-form-item label="年">
                <el-input v-model="dataForm.year"></el-input>
              </el-form-item>
              <el-form-item label="月">
                <el-input v-model="dataForm.month"></el-input>
              </el-form-item>
              <el-form-item label="卷">
                <el-input v-model="dataForm.roll"></el-input>
              </el-form-item>
              <el-form-item label="期">
                <el-input v-model="dataForm.issue"></el-input>
              </el-form-item>
              <el-form-item label="页码(文献号)">
                <el-input v-model="dataForm.page"></el-input>
              </el-form-item>
              <el-form-item label="论文类型">
                <el-select v-model="dataForm.paperTypeId" placeholder="请选择" class="sel-c">
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="DOI">
                <el-input v-model="dataForm.doi"></el-input>
              </el-form-item>
              <el-form-item label="入藏号">
                <el-input v-model="dataForm.wosid"></el-input>
              </el-form-item>
              <el-form-item label="PMID">
                <el-input v-model="dataForm.pmid"></el-input>
              </el-form-item>
              <el-form-item label="投稿登记号">
                <el-input v-model="dataForm.registrationNumber"></el-input>
              </el-form-item>
              <el-form-item label="投稿登记号附件">
                <el-upload
                  class="upload-demo"
                  action
                  :http-request="handleFile"
                  :on-change="reg_path_file"
                  :multiple="false"
                  :limit="1"
                  :file-list="reg_file_list"
                  accept=".jpg, .jpeg, .png, .pdf"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">注:仅限jpg、jpeg、png、pdf等格式</div>
                </el-upload>
              </el-form-item>
              <el-form-item label="是否需要报销">
                <el-select
                  v-model="dataForm.expenseFlag"
                  placeholder="请选择"
                  @change="flagChange"
                  class="sel-c"
                >
                  <el-option
                    v-for="item in isOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否国际合作">
                <el-select v-model="dataForm.isInternational" placeholder="请选择" class="sel-c">
                  <el-option
                    v-for="item in isOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="请上传全文">
                <el-upload
                  class="upload-demo"
                  action
                  :http-request="handleFile"
                  :on-change="path_file"
                  :multiple="false"
                  :limit="1"
                  :file-list="file_list"
                  accept=".pdf"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">注:仅限pdf格式</div>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="doAddOrUpdate(1)">保存至草稿箱</el-button>
                <el-button type="primary" @click="doAddOrUpdate(2)">成果提交</el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </el-card>
        <el-dialog title="作者信息" :visible.sync="dialogVisible1" width="1100px">
          <div class="author-box">
            <el-form ref="authorsForm" label-width="100px" size="medium">
              <div v-for="(item,index) in authorsForm" :key="index" style="margin-bottom: 15px;">
                <p class="author-ipt">
                  <span>工号</span>
                  <el-input v-model="item.jobNo"></el-input>
                </p>
                <p class="author-ipt">
                  <span>作者</span>
                  <el-input v-model="item.author"></el-input>
                </p>
                <p class="author-ipt">
                  <span>排序</span>
                  <el-input v-model="item.ranges"></el-input>
                </p>
                <p class="author-sel">
                  <span>是否第一作者</span>
                  <el-select v-model="item.authorType" placeholder="请选择" class="sel-c">
                    <el-option
                      v-for="item in isOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </p>
                <p class="author-sel">
                  <span>是否通讯作者</span>
                  <el-select v-model="item.coAuthor" placeholder="请选择" class="sel-c">
                    <el-option
                      v-for="item in isOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </p>
                <p class="author-sel">
                  <span>部门</span>
                  <el-select v-model="item.deptId" placeholder="请选择" class="sel-c">
                    <el-option
                      v-for="item in depOptions"
                      :key="item.id"
                      :label="item.typeName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </p>
                <p class="author-btn">
                  <el-button v-if="index===0" icon="el-icon-plus" @click="addAuthor(index)"></el-button>
                  <el-button v-else icon="el-icon-minus" @click="reduceAuthor(index)"></el-button>
                </p>
              </div>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible1 = false">取 消</el-button>
            <el-button type="primary" @click="subAuthor">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="账户信息" :visible.sync="dialogVisible2" width="900px">
          <div>
            <el-button size="small" @click="isAdd = true">新增</el-button>
            <el-radio-group v-model="dataForm.add" style="width: 100%;">
              <el-table :data="tableData" style="width: 100%">
                <el-table-column label="选择" width="100">
                  <template slot-scope="scope">
                    <el-radio :label="scope.row.id"></el-radio>
                  </template>
                </el-table-column>
                <el-table-column prop="accountName" label="姓名" width="215"></el-table-column>
                <el-table-column prop="account" label="账号" width="215"></el-table-column>
                <el-table-column prop="openAccount" label="开户行" width="215"></el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button @click="delCick(scope.row.id)" size="small">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div style="padding-top: 15px;" v-show="isAdd">
                <span style="display:inline-block;width: 100px;text-align: center;">
                  <el-radio v-model="addAccount.id" label></el-radio>
                </span>
                <span style="display:inline-block;width: 215px;">
                  <el-input v-model="addAccount.accountName"></el-input>
                </span>
                <span style="display:inline-block;width: 215px;">
                  <el-input v-model="addAccount.account"></el-input>
                </span>
                <span style="display:inline-block;width: 215px;">
                  <el-input v-model="addAccount.openAccount"></el-input>
                </span>
                <span style="display:inline-block;text-align: center;width: 115px;">
                  <el-button size="small" @click="addAccount1">保存</el-button>
                </span>
              </div>
            </el-radio-group>
          </div>
          <span slot="footer" class="dialog-footer">
            <!-- <el-button @click="dialogVisible2 = false">取 消</el-button> -->
            <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
          </span>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import centerLeft from '../../components/center-left.vue'
export default {
  name: 'claim',
  components: {
    centerLeft,
  },
  data() {
    return {
      activeName: 'second',
      isRouter: true,
      dialogVisible1: false,
      dialogVisible2: false,
      isAdd: false,
      file_list: [],
      reg_file_list: [],
      typeOptions: [
        { value: '', label: '--请选择--' },
        { value: '18', label: 'Article（论文）' },
        { value: '19', label: 'Editorial Material（社论材料）' },
        { value: '20', label: 'Letter（书信）' },
        { value: '21', label: 'Meeting Abstract（会议摘要）' },
        { value: '22', label: 'Proceedings Paper（会议录论文）' },
        { value: '23', label: 'Review（评论）' },
        { value: '24', label: 'Other（其它）' },
      ],
      authors: '',
      addAccount: {
        id: '',
        accountName: '',
        account: '',
        openAccount: '农业银行',
        userId: 21,
      },
      tableData: [],
      isOptions: [
        { value: '', label: '--请选择--' },
        { value: 1, label: '是' },
        { value: 0, label: '否' },
      ],
      depOptions: [],
      dataForm: {
        chtitle: '',
        title: '',
        author: [],
        issn: '',
        journalName: '',
        year: '',
        month: '',
        roll: '',
        issue: '',
        page: '',
        paperTypeId: '',
        doi: '',
        wosid: '',
        pmid: '',
        registrationNumber: '',
        expenseFlag: '',
        add: '',
        isInternational: '',
      },
      rules: {
        author: [{ required: true, message: '请输入作者', trigger: 'blur' }],
        journalName: [
          { required: true, message: '请输入期刊名', trigger: 'blur' },
        ],
        year: [{ required: true, message: '请输入年', trigger: 'blur' }],
        page: [
          { required: true, message: '请输入页码(文献号)', trigger: 'blur' },
        ],
        registrationNumber: [
          { required: true, message: '请输入投稿登记号', trigger: 'blur' },
        ],
        expenseFlag: [
          { required: true, message: '请输入是否需要报销', trigger: 'blur' },
        ],
      },
      authorsForm: [
        {
          jobNo: '',
          author: '',
          ranges: 1,
          authorType: '',
          coAuthor: '',
          deptId: '',
        },
      ],
    }
  },
  methods: {
    handleFile() {},
    reg_path_file(file, fileList) {
      this.reg_file_list = fileList
    },
    path_file(file, fileList) {
      this.file_list = fileList
    },
    getAllDep() {
      let currThis = this
      axios({
        method: 'get',
        url: '/api/Depart/index',
      })
        .then(function (response) {
          console.log(response)
          let arr = [{ id: '-1', typeName: '非本院' }]
          currThis.depOptions = arr.concat(response.data.data.deptTypelist)
        })
        .catch(function (thrown) {
          console.log(thrown)
        })
    },
    addAccount1() {
      let arr = this.tableData
      arr.push(this.addAccount)
      this.tableData = arr
    },
    addAuthor(index) {
      let arr = this.authorsForm
      let obj = {
        jobNo: '',
        author: '',
        authorType: '',
        coAuthor: '',
        deptId: '',
      }
      obj.ranges = index + 1
      arr.push(obj)
      this.authorsForm = arr
    },
    reduceAuthor(index) {
      let arr = this.authorsForm
      arr.splice(index, 1)
      this.authorsForm = arr
    },
    subAuthor() {
      let arr = this.authorsForm
      this.dataForm.author = arr
      this.dialogVisible1 = false
      let str = ''
      for (var i in this.dataForm.author) {
        if (i != 0) {
          str = str + ',' + this.dataForm.author[i].author
        } else {
          str = this.dataForm.author[i].author
        }
      }
      this.authors = str
    },
    flagChange() {
      console.log(this.dataForm.expenseFlag)
      if (this.dataForm.expenseFlag == 1) {
        this.dialogVisible2 = true
      }
    },
    delCick(id) {
      let arr = this.tableData
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id === id) {
          arr.splice(i, 1)
        }
      }
      this.tableData = arr
    },
    getData(id) {
      let currThis = this
      //认领
      axios({
        method: 'get',
        url:
          '/api/member/foregin/initAdd/' +
          this.userId +
          '/' +
          this.$route.query.id +
          '/1',
      })
        .then(function (response) {
          console.log(response)
          currThis.dataForm = response.data.data.irForeginDiss
          currThis.dataForm.gmtPublish = currThis.formatDate(
            currThis.dataForm.gmtPublish
          )
          currThis.authors = response.data.data.irForeginDiss.author
          currThis.authorsForm = response.data.data.dissAuthorList
        })
        .catch(function (thrown) {
          console.log(thrown)
        })
    },
    getAccount() {
      let currThis = this
      axios({
        method: 'get',
        url: '/api/getAccount?userId=' + this.userId,
      })
        .then(function (response) {
          console.log(response)
          currThis.tableData = response.data
        })
        .catch(function (thrown) {
          console.log(thrown)
        })
    },
    formatDate(date) {
      var now = new Date(date)
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      return (
        year +
        '-' +
        this.addZero(month) +
        '-' +
        this.addZero(date) +
        ' ' +
        this.addZero(hour) +
        ':' +
        this.addZero(minute) +
        ':' +
        this.addZero(second)
      )
    },
    addZero(num) {
      if (parseInt(num) < 10) {
        num = '0' + num
      }
      return num
    },
    doAddOrUpdate(val) {
      let obj = this.dataForm
      obj.author = this.authors
      obj.state = val
      obj.id = Number(this.$route.query.id)
      let currThis = this
      var formData = new FormData()
      formData.set('fileObj', this.file_list[0] ? this.file_list[0].raw : '')
      formData.set(
        'registrationFileInfo',
        this.reg_file_list[0] ? this.reg_file_list[0].raw : ''
      )
      let deps = []
      let first = []
      let cos = []
      let jobs = []
      let rgs = []
      for (let i = 0; i < this.authorsForm.length; i++) {
        if (this.authorsForm[i].authorType != '-1') {
          if (
            this.authorsForm[i].deptId == '' ||
            this.authorsForm[i].deptId == undefined
          ) {
            deps.push('-1')
          } else {
            deps.push(this.authorsForm[i].deptId)
          }
          first.push(this.authorsForm[i].authorType)
          cos.push(this.authorsForm[i].coAuthor)
          jobs.push(this.authorsForm[i].jobNo)
          rgs.push(this.authorsForm[i].ranges)
        }
      }
      formData.append('deptIds', deps.join(','))
      formData.append('firstAuthors', first.join(','))
      formData.append('coAuthors', cos.join(','))
      formData.append('jobNos', jobs.join(','))
      formData.append('ranges', rgs.join(','))
      formData.append('sign', val)
      formData.append('flag', 1)
      for (var a in obj) {
        if (obj[a]) {
          if (a.__proto__ === Array.prototype) {
            let v = obj[a]
            for (let i = 0; i < v.length; i++) {
              formData.append(a, obj[a][i])
            }
          } else {
            formData.append(a, obj[a])
          }
        }
      }
      //认领
      axios({
        method: 'post',
        url: '/api/foregin/doAddOrUpdate',
        data: formData,
      })
        .then(function (response) {
          if (response.data.code == '8001') {
            currThis.$router.push({
              path: '/center/claim',
            })
          }
          alert(response.data.msg)
          console.log(obj)
          console.log(response)
        })
        .catch(function (thrown) {
          console.log(thrown)
        })

      // let obj=this.dataForm
      // obj.state=val;
      // obj.id=Number(this.$route.query.id);
      // let currThis=this;
      // axios({
      // 	method: 'post',
      // 	url: '/api/foregin/doAddOrUpdate',
      // 	data:obj
      // }).then(function (response) {
      // 	alert(response.data.msg)
      // 	console.log(obj);
      // 	console.log(response);
      // }).catch(function (thrown) {
      // 	console.log(thrown)
      // });
    },
  },
  mounted() {
    this.userId = this.$cookies.get('rtnVal')
    if (this.$route.query.id) {
      this.getData()
    }
    this.getAllDep()
    this.getAccount()
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/center/foreign.vue